module.exports = __webpack_public_path__ + "img/infinity7.74712463.jpg";